import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/utils";

export const APP_LOGO_SRC = "/appLogo.jpg";

export type AppLogoProps = Omit<ComponentPropsWithoutRef<"img">, "src"> & {
  /**
   * `chrome` — sit on solid theme color + multiply removes flat white from raster logo.
   * `raw` — plain `<img>` (e.g. print or special cases).
   */
  variant?: "raw" | "chrome";
  /** Wrapper when variant is chrome */
  frameClassName?: string;
};

export function AppLogo({
  variant = "chrome",
  className,
  frameClassName,
  alt = "FINGENT",
  ...imgProps
}: AppLogoProps) {
  const img = (
    <img
      src={APP_LOGO_SRC}
      alt={alt}
      className={cn(
        "object-contain",
        variant === "chrome" && "[mix-blend-mode:multiply] contrast-[1.04]",
        className,
      )}
      {...imgProps}
    />
  );

  if (variant === "chrome") {
    return (
      <span
        className={cn(
          "flex shrink-0 items-center justify-center overflow-hidden rounded-lg border bg-sidebar",
          "border-sidebar-border/60",
          frameClassName,
        )}
      >
        {img}
      </span>
    );
  }

  return img;
}
